import { Input } from "@headlessui/react";
import SearchIcon from "@/assets/icons/search-lg.svg?react";
import "rsuite/DateRangePicker/styles/index.css";
import { useTranslation } from "react-i18next";

type InvoicesFilterProps = {
  setSearchField: React.Dispatch<React.SetStateAction<string>>;
  searchField: string;
};

export const BlockedInvoicesFilter = ({ setSearchField, searchField }: InvoicesFilterProps) => {
  const { t } = useTranslation("boInvoices");
  return (
    <div className="flex w-full flex-col justify-start gap-2">
      <div className="flex max-w-[300px] flex-col items-start gap-2 lg:max-w-screen lg:flex-row lg:items-center">
        <div className="flex h-[46px] w-full min-w-[150px] flex-row items-center gap-3 rounded-lg border border-solid border-gray-300 bg-white px-3 py-2 lg:max-w-[268px]">
          <SearchIcon />
          <Input
            value={searchField}
            onChange={(e) => setSearchField(e.target.value)}
            className="w-full text-sm font-medium focus:outline-hidden"
            placeholder={t("blockedFilter.searchPlaceholder")}
          />
        </div>
      </div>
    </div>
  );
};
